import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: 0,
};

const getInitialStateCreateReservation = localStorage.getItem(
  "createReservation",
)
  ? JSON.parse(localStorage.getItem("createReservation"))
  : 0;

const initialStateCreateReservation =
  getInitialStateCreateReservation === 0
    ? {
        value: 0,
      }
    : {
        reservation_created: getInitialStateCreateReservation,
      };

export const closedOpenExceptionsDatePickerSlice = createSlice({
  name: "openClosedExceptions",
  initialState,
  reducers: {
    openClosedExceptionsRequest: (state) => {
      state.isLoading = true;
    },
    openClosedExceptionsSucess: (state, action) => {
      state.openClosedExceptions = action.payload;
      state.isLoading = false;
    },
    openClosedExceptionsError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const reservationBlockedWeekdaysSlice = createSlice({
  name: "reservationBlockedWeekdays",
  initialState,
  reducers: {
    reservationBlockedWeekdaysRequest: (state) => {
      state.isLoading = true;
      state.error = false;
    },
    reservationBlockedWeekdaysSucess: (state, action) => {
      state.blockedWeekdays = action.payload;
      state.isLoading = false;
    },
    reservationBlockedWeekdaysError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    // Checking if restaurant is still open in the correct time zone
    isRestaurantOpenTodayRequest: (state) => {
      state.loadingIsRestaurantOpen = true;
      state.errorIsRestaurantOpen = false;
    },
    isRestaurantOpenTodaySucess: (state, action) => {
      state.isRestaurantOpen = action.payload;
      state.loadingIsRestaurantOpen = false;
    },
    isRestaurantOpenTodayError: (state, action) => {
      state.errorIsRestaurantOpen = action.payload;
      state.loadingIsRestaurantOpen = false;
    },
    // Checking if restaurant is still open in the correct time zone
    restaurantTimeZoneRequest: (state) => {
      state.loadingRestaurantTimeZone = true;
      state.errorIsRestaurantTimeZone = false;
    },
    restaurantTimeZoneSucess: (state, action) => {
      state.restaurantTimeZone = action.payload;
      state.loadingRestaurantTimeZone = false;
    },
    restaurantTimeZoneError: (state, action) => {
      state.errorIsRestaurantTimeZone = action.payload;
      state.loadingRestaurantTimeZone = false;
    },
  },
});

export const reservationZoneSlice = createSlice({
  name: "reservationZones",
  initialState,
  reducers: {
    reservationZoneRequest: (state) => {
      state.isZonesLoading = true;
    },
    reservationZoneSucess: (state, action) => {
      state.zones = action.payload;
      state.isZonesLoading = false;
    },
    reservationZoneError: (state, action) => {
      state.zonesError = action.payload;
      state.isZonesLoading = false;
    },
  },
});

export const openTimeSlice = createSlice({
  name: "openTime",
  initialState,
  reducers: {
    openTimeRequest: (state) => {
      state.isLoading = true;
      state.openTime = [];
    },
    openTimeSucess: (state, action) => {
      state.openTime = action.payload;
      state.isLoading = false;
    },
    openTimeError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const createReservationSlice = createSlice({
  name: "createReservation",
  initialState: initialStateCreateReservation,
  reducers: {
    createReservationRequest: (state) => {
      state.isLoading = true;
      state.reservation_created = false;
      state.createReservationFailed = false;
      state.createReservationSuccess = false;
      state.error = false;
    },
    createReservationSucess: (state, action) => {
      state.reservation_created = action.payload;
      state.isLoading = false;
      state.error = false;
      state.createReservationFailed = false;
      state.createReservationSuccess = true;
    },
    createReservationError: (state, action) => {
      state.error = action.payload;
      state.createReservationSuccess = false;
      state.createReservationFailed = true;
      state.isLoading = false;
    },
    createReservationSuccessErrorReset: (state) => {
      state.error = false;
      state.createReservationSuccess = false;
      state.createReservationFailed = false;
      state.isLoading = false;
    },

    // update reservation
    reservationUpdateStart: (state) => {
      state.reservationUpdateIsLoading = true;
    },
    reservationUpdateSucess: (state, action) => {
      state.reservationUpdate = action.payload;
      state.reservationUpdateIsLoading = false;
    },
    reservationUpdateError: (state, action) => {
      state.reservationUpdateError = action.payload;
      state.reservationUpdateIsLoading = false;
    },
    // postPhoneConfirmation
    postPhoneConfirmationStart: (state) => {
      state.isPhoneConfirmationLoading = true;
    },
    postPhoneConfirmationSucess: (state, action) => {
      state.phoneConfirmation = action.payload;
      state.isPhoneConfirmationLoading = false;
    },
    postPhoneConfirmationError: (state, action) => {
      state.phoneConfirmationError = action.payload;
      state.isPhoneConfirmationLoading = false;
    },
    postPhoneConfirmationReset: (state) => {
      state.phoneConfirmationError = false;
      state.isPhoneConfirmationLoading = false;
      state.phoneConfirmation = false;
    },
    // postResendPhoneConfirmation
    postResendPhoneConfirmationStart: (state) => {
      state.isResendPhoneConfirmationLoading = true;
    },
    postResendPhoneConfirmationSucess: (state, action) => {
      state.resendPhoneConfirmation = action.payload;
      state.isResendPhoneConfirmationLoading = false;
    },
    postResendPhoneConfirmationError: (state, action) => {
      state.resendPhoneConfirmationError = action.payload;
      state.isResendPhoneConfirmationLoading = false;
    },
    // postCheckCancel
    postCheckCancelStart: (state) => {
      state.checkCancel = false;
      state.isCheckCancelLoading = true;
    },
    postCheckCancelSucess: (state, action) => {
      state.checkCancel = action.payload;
      state.isCheckCancelLoading = false;
    },
    postCheckCancelError: (state, action) => {
      state.checkCancelnError = action.payload;
      state.isCheckCancelLoading = false;
    },
    // postCheckCancel
    postReconfirmationByClient: (state) => {
      state.reconfirmationByClient = false;
      state.reconfirmationByClientLoading = true;
    },
    postReconfirmationByClientSucess: (state, action) => {
      state.reconfirmationByClient = action.payload;
      state.reconfirmationByClientLoading = false;
    },
    postReconfirmationByClientError: (state, action) => {
      state.reconfirmationByClientError = action.payload;
      state.reconfirmationByClientLoading = false;
    },

    // reset
    resetReservationError: () => {
      return {};
    },
  },
});

export const cancelReservationSlice = createSlice({
  name: "cancelReservation",
  initialState,
  reducers: {
    cancelReservationRequest: (state) => {
      state.isLoadingCancel = true;
    },
    cancelReservationSucess: (state, action) => {
      state.cancelMessage = action.payload;
      state.isLoadingCancel = false;
    },
    cancelReservationError: (state, action) => {
      state.error = action.payload;
      state.isLoadingCancel = false;
    },
  },
});

export const editReservationSlice = createSlice({
  name: "editReservation",
  initialState,
  reducers: {
    editReservationRequest: (state) => {
      state.isLoadingEditReservation = true;
    },
    editReservationSucess: (state, action) => {
      state.editReservation = action.payload;
      state.isLoadingEditReservation = false;
    },
    editReservationError: (state, action) => {
      state.errorEditReservations = action.payload;
      state.isLoadingEditReservation = false;
    },
  },
});

export const reservationCustomersMenuSlice = createSlice({
  name: "cancelReservation",
  initialState,
  reducers: {
    getReservationCustomerRequest: (state) => {
      state.isLoading = true;
    },
    getReservationCustomerSucess: (state, action) => {
      state.reservation = action.payload;
      state.isLoading = false;
    },
    getReservationCustomerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    // Special Loader for customer menu so it doesnt load the loader component wen the page it's autoupdating itself
    startCustomerMenuLoader: (state, action) => {
      state.isCustomerLoader = true;
    },
    stopCustomerMenuLoader: (state, action) => {
      state.isCustomerLoader = false;
    },
    resetReservationCustomerMenu: () => {
      return {};
    },
  },
});

export const reservationLimitPeopleBabySlice = createSlice({
  name: "reservationLimitPeopleBaby",
  initialState,
  reducers: {
    getPeopleBabyRequest: (state) => {
      state.isLoading = true;
    },
    getLimitsPeopleBabySucess: (state, action) => {
      state.limitPeopleBaby = action.payload;
      state.isLoading = false;
    },
    getPeopleBabyError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const reservationActiveSlice = createSlice({
  name: "reservationActive",
  initialState,
  reducers: {
    getReservationActiveRequest: (state) => {
      state.isActive = true;
    },
    getReservationActiveError: (state, action) => {
      state.error = action.payload;
    },
    getReservationDeactivateRequest: (state, action) => {
      state.isActive = false;
    },
  },
});

export const reservationPhoneOrEmailConfirmationSlice = createSlice({
  name: "reservationPhoneOrEmailConfirmation",
  initialState,
  reducers: {
    getPhoneOrEmailConfirmationRequest: (state) => {
      state.isPhoneOrEmailConfirmationLoading = true;
    },
    getPhoneOrEmailConfirmationSucess: (state, action) => {
      state.phoneOrEmailConfirmation = action.payload;
      state.isPhoneOrEmailConfirmationLoading = false;
    },
    getPhoneOrEmailConfirmationError: (state, action) => {
      state.phoneOrEmailConfirmationError = action.payload;
      state.isPhoneOrEmailConfirmationLoading = false;
    },
  },
});
